import React from 'react';
import { shape, string } from 'prop-types';
import {
  Typography,
  withStyles,
} from '@material-ui/core';

import styles from './styles';
import formatDateString from '../../../utils/datetime';
import StatusIndicator from '../../StatusIndicator';

export const DetailsHeader = (props) => {
  const {
    classes,
    headerId,
    title,
    name,
    modifyTs,
    status,
  } = props;

  const lastModified = modifyTs && formatDateString(new Date(modifyTs).toString());

  return (
    <div
      className={classes.headerContainer}
      id={headerId} data-apim-test={headerId} data-layer7-test={headerId}
    >
      <Typography variant="h6" className={classes.pageTitle}>
        {title}
      </Typography>
      <Typography variant="h1" className={classes.pageTitle}>{name}</Typography>
      <StatusIndicator
        status={status}
        lastModified={lastModified}
      />
    </div>
  );
};

DetailsHeader.propTypes = {
  classes: shape({}),
  headerId: string,
  title: string,
  name: string,
  modifyTs: string,
  status: string,
};
DetailsHeader.displayName = 'DetailsHeader';

export default withStyles(styles)(DetailsHeader);



// WEBPACK FOOTER //
// ./src/components/Details/Header/index.js